import { IKeyValueLog } from '../Entity/IKeyValueLog';
import { IEmotionRecordDTO } from '../DTOs/IEmotionRecordDTO';

export const legacyMaximumEmotionValue = 7;
export const rawMaximumEmotionValue = 8;
export const integratedPlusEmotionCharacter = 'I+';

export function GetDailyAverageEmotionValue(keyValues: IKeyValueLog[]) {
	const emotionValues: number[] = keyValues
		.map((kvl) => kvl.value)
		.map(GetLegacyEmotionValueFromCharacter);

	if (emotionValues.length === 0) {
		return 0;
	}

	const averageEmotionValue =
		emotionValues.reduce((a, b) => a + b) / emotionValues.length;

	const result = Number.parseFloat(averageEmotionValue.toFixed(2));
	return result;
}

export function GetAverageEmotionValues(dtos: IEmotionRecordDTO[]) {
	const dailyAverages: number[] = dtos
		.map((dto) => dto.average);

	if (dailyAverages.length === 0) {
		return 0;
	}

	const averageEmotionValue =
		dailyAverages.reduce((a, b) => a + b) / dailyAverages.length;

	const result = Number.parseFloat(averageEmotionValue.toFixed(2));
	return result;
}

export function GetEmotionValueFromCharacter(emotionCharacter: string) {
	if (emotionCharacter === 'A') return 0;
	if (emotionCharacter === 'T') return 1;
	if (emotionCharacter === 'U') return 2;
	if (emotionCharacter === 'C') return 3;
	if (emotionCharacter === 'F') return 4;
	if (emotionCharacter === '^') return 5;
	if (emotionCharacter === 'P') return 6;
	if (emotionCharacter === 'I') return 7;
	if (emotionCharacter === integratedPlusEmotionCharacter) return rawMaximumEmotionValue;
	return -1;
}

export function GetLegacyEmotionValueFromCharacter(emotionCharacter: string) {
	const rawValue = GetEmotionValueFromCharacter(emotionCharacter);
	return rawValue < 0
		? rawValue
		: Math.min(rawValue, legacyMaximumEmotionValue);
}
